import { Container } from './Container';

/** Bright, warm page-header band (cream → blush → gold wash). */
export function PageHeader({ eyebrow, title, intro }: { eyebrow?: string; title: string; intro?: string }) {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-blush-soft via-cream to-cream pb-16 pt-36 text-center">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0"
        style={{ background: 'radial-gradient(70% 60% at 50% 0%, rgba(201,150,46,0.18), transparent 60%)' }}
      />
      <Container className="relative z-10">
        {eyebrow && <p className="eyebrow mb-4">{eyebrow}</p>}
        <h1 className="font-display text-5xl font-medium text-espresso sm:text-6xl">{title}</h1>
        <div className="rule-gold mx-auto mt-6" />
        {intro && <p className="mx-auto mt-6 max-w-xl font-body text-muted">{intro}</p>}
      </Container>
    </section>
  );
}
